import React from 'react'
import { Row, Col, Typography } from 'antd'

const { Title } = Typography

const SupplierInfoPanel = ({ supplier, styles }) => {
  return (
    <>
      <Title level={5} className={styles.supplierInfoTitle}>
        Supplier Information
      </Title>
      <Row gutter={24}>
        <Col span={12}>
          <p>
            <strong>Contact:</strong> {supplier.contactPerson}
          </p>
          <p>
            <strong>Email:</strong> {supplier.email}
          </p>
        </Col>
        <Col span={12}>
          <p>
            <strong>Phone:</strong> {supplier.phone}
          </p>
          <p>
            <strong>Lead Time:</strong> {supplier.leadTimeDays} days
          </p>
        </Col>
      </Row>
    </>
  )
}

export default SupplierInfoPanel
